import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE_AMOUNT, PRICE_COMPARE, PRICE_CURRENCY } from '../data/hockey';
const recap = ['6 Volumes', '5 Bonuses', '~240 Pages', 'A 40-Week Season Plan'];
const reassurances = ['Instant digital access', 'Printable PDFs', '7-day satisfaction guarantee'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-112" data-mp="1jd51zqavs64x">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-113" data-mp="1ee1ulz7fhnts" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-114" data-mp="1t37s9iqmb5zk">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-115" data-mp="1t4r9pco0fn2x">
          Your Season Can Be <em className="text-red-700" data-id="element-116" data-mp="2233au8mi639m">Planned Today.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-117" data-mp="2219yqdt4equ8">
          Instead of searching for drills, building every practice yourself, and spending Sunday
          nights planning, have your whole field hockey season organized and ready to run. More time
          for what matters:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-118" data-mp="x38yfqdjfs3s">
          Your Players. Your Coaching. Your Life Off the Field.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-119" data-mp="120ion88r47so">
          {recap.map(item => <li key={item} data-id="element-120" data-mp="1b2rtpil938yo">{item}</li>)}
        </ul>

        <p className="mt-8 text-lg text-slate-900/50" data-id="element-121" data-mp="1b1gr3m3jk795">
          Regular price <s data-id="element-122" data-mp="1fvkyu7kmsjba">{PRICE_COMPARE} {PRICE_CURRENCY}</s>
        </p>
        <p className="mt-2 whitespace-nowrap font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1kt38k06h32kc">
          {PRICE_AMOUNT}
          <span className="ml-2 text-2xl tracking-normal text-slate-900/70 sm:text-3xl" data-id="element-124" data-mp="1pu0tgkivaapj">{PRICE_CURRENCY}</span>
        </p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-125" data-mp="1troqbt44edk2">One-time payment — no subscription.</p>

        <div className="mt-8 flex justify-center" data-id="element-126" data-mp="3qskv8i4s04r8">
          <CtaButton className="w-full sm:w-auto" data-id="element-127" data-mp="3lwdowo8gwr8r" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-128" data-mp="3hl75bvpameq">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-129" data-mp="3uw0m0xu5zaw0">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-130" data-mp="dfskzlup0oci" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}